const initialState = {
  loading: false,
  data: null,
  error: null,
};

const youtubeLinksReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_YOUTUBE_LINKS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_YOUTUBE_LINKS_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_YOUTUBE_LINKS_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default youtubeLinksReducer;
